module.exports = __webpack_public_path__ + "img/image_aegean.b3eeaf8d.png";